import { PropsWithChildren, useContext } from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { TabsReactContext } from "src/components-mui/tabs/tabs-context";

interface ITabPanelProps {
    keepMounted?: boolean;
    value?: string | number;
    sx?: SxProps<Theme>;
}

export const TabPanel = ({ keepMounted = true, children, value, sx }: PropsWithChildren<ITabPanelProps>) => {
    const context = useContext(TabsReactContext);

    return (
        <Box sx={{ display: context.currentTab == value ? "block" : "none", ...sx }}>
            {context.currentTab === value && (keepMounted ? children : null)}
        </Box>
    );
};
